import React from "react";
import { Text } from "@chakra-ui/react";
import QuestionnaireStages from "./QuestionnaireStages";
import IssbContainer from "../../IssbContainer";
import { useSelector } from "react-redux";
import RoundList from "pages/ISSB/components/NavItems/RoundList";
import PageHeader from "../../../../components/text/PageHeader";

/**
 * Configure Workflow Stages
 * @returns
 */
const IssbStageSetupPage = () => {
  const roundSelector = useSelector((state) => state.issbRound);

  if (!roundSelector?.selectedRound) {
    return (
      <IssbContainer>
        <Text color="darkTeal" fontSize="body.m" my={4}>
          Please select a round
        </Text>
        <RoundList variant="secondary" />
      </IssbContainer>
    );
  }

  return (
    <IssbContainer>
      <PageHeader
        title="Workflow Stages"
        subTitle="Configure the workflow stages for this round. Define the steps disclosures move through from start to completion."
      />
      <QuestionnaireStages />
    </IssbContainer>
  );
};

export default IssbStageSetupPage;
